import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponsManagementTable from "../../components/CouponsManagement/CouponsManagementTable";




const CouponsManagementPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Coupons Management" />
                <CouponsManagementTable/>
      



            </MasterLayout>
        </>
    );
};

export default CouponsManagementPage;
